import VError from '../views/VError.vue'
import VIndex from '../views/VIndex.vue'
import VTerms from '../views/VTerms.vue'

import VBooking from '../views/VBooking.vue'
import VBookingOverview from '../views/VBookingOverview.vue'
import VBookingTours from '../views/VBookingTours.vue'
import VBookingPersonalInformation from '../views/VBookingPersonalInformation.vue'
import VBookingConfirmation from '../views/VBookingConfirmation.vue'
import VBookingError from '../views/VBookingError.vue'

import VReservation from '../views/VReservation.vue'
import VReservationProcess from '../views/VReservationProcess.vue'
import VReservationOverview from '../views/VReservationOverview.vue'
import VReservationPersonalInformation from '../views/VReservationPersonalInformation.vue'
import VReservationConfirmation from '../views/VReservationConfirmation.vue'
import VReservationCancelation from '../views/VReservationCancelation.vue'

import VGiftCards from '../views/VGiftCards.vue'

import VBookingYullbe from '../views/VBookingYullbe.vue'

export default [
  // Index
  {
    path: '/',
    component: VIndex
  },

  // Booking
  {
    path: '/booking/overview',
    name: 'booking-overview-en',
    meta: { lang: 'en' },
    component: VBookingOverview
  },
  {
    path: '/buchung/uebersicht',
    name: 'booking-overview-de',
    meta: { lang: 'de' },
    component: VBookingOverview
  },
  {
    path: '/booking/tours/:date?',
    name: 'booking-tours-en',
    meta: { lang: 'en' },
    component: VBookingTours
  },
  {
    path: '/buchung/fuehrungen/:date?',
    name: 'booking-tours-de',
    meta: { lang: 'de' },
    component: VBookingTours
  },
  {
    path: '/booking/personal-information',
    name: 'booking-personal-information-en',
    meta: { lang: 'en' },
    component: VBookingPersonalInformation
  },
  {
    path: '/buchung/persoenliche-daten',
    name: 'booking-personal-information-de',
    meta: { lang: 'de' },
    component: VBookingPersonalInformation
  },
  {
    path: '/booking/confirmation/:referenceid?',
    name: 'booking-confirmation-en',
    meta: { lang: 'en', type: 'confirmation' },
    component: VBookingConfirmation
  },
  {
    path: '/buchung/bestaetigung/:referenceid?',
    name: 'booking-confirmation-de',
    meta: { lang: 'de', type: 'confirmation' },
    component: VBookingConfirmation
  },
  {
    path: '/booking/wallet-download/:referenceid?',
    name: 'booking-confirmation-wallet-en',
    meta: { lang: 'en', type: 'wallet' },
    component: VBookingConfirmation
  },
  {
    path: '/buchung/wallet-download/:referenceid?',
    name: 'booking-confirmation-wallet-de',
    meta: { lang: 'de', type: 'wallet' },
    component: VBookingConfirmation
  },
  {
    path: '/booking/error',
    name: 'booking-error-en',
    meta: { lang: 'en' },
    component: VBookingError
  },
  {
    path: '/buchung/fehler',
    name: 'booking-error-de',
    meta: { lang: 'de' },
    component: VBookingError
  },
  {
    path: '/booking/event/:date?',
    name: 'booking-event-en',
    meta: { lang: 'en', spawn: true },
    component: VBooking
  },
  {
    path: '/buchung/sonderveranstaltung/:date?',
    name: 'booking-event-de',
    meta: { lang: 'de', spawn: true },
    component: VBooking
  },
  {
    path: '/booking/:date?/:people?',
    name: 'booking-en',
    meta: { lang: 'en' },
    component: VBooking
  },
  {
    path: '/buchung/:date?/:people?',
    name: 'booking-de',
    meta: { lang: 'de' },
    component: VBooking
  },

  // Reservation
  {
    path: '/reservation/overview',
    name: 'reservation-overview-en',
    meta: { lang: 'en' },
    component: VReservationOverview
  },
  {
    path: '/reservierung/uebersicht',
    name: 'reservation-overview-de',
    meta: { lang: 'de' },
    component: VReservationOverview
  },
  {
    path: '/reservation/personal-information',
    name: 'reservation-personal-information-en',
    meta: { lang: 'en' },
    component: VReservationPersonalInformation
  },
  {
    path: '/reservierung/persoenliche-daten',
    name: 'reservation-personal-information-de',
    meta: { lang: 'de' },
    component: VReservationPersonalInformation
  },
  {
    path: '/reservation/process/',
    name: 'reservation-process-en',
    meta: { lang: 'en' },
    component: VReservationProcess
  },
  {
    path: '/reservierung/bearbeitung/',
    name: 'reservation-process-de',
    meta: { lang: 'de' },
    component: VReservationProcess
  },
  {
    path: '/reservation/:barcode/confirm/',
    name: 'reservation-confirmation-en',
    meta: { lang: 'en' },
    component: VReservationConfirmation
  },
  {
    path: '/reservation/:barcode/cancel/',
    name: 'reservation-cancel-en',
    meta: { lang: 'en' },
    component: VReservationCancelation
  },
  {
    path: '/reservierung/:barcode/stornieren/',
    name: 'reservation-cancel-de',
    meta: { lang: 'de' },
    component: VReservationCancelation
  },
  {
    path: '/reservierung/:barcode/bestaetigen/',
    name: 'reservation-confirmation-de',
    meta: { lang: 'de' },
    component: VReservationConfirmation
  },
  {
    path: '/reservation/:date?/:people?',
    name: 'reservation-en',
    meta: { lang: 'en' },
    component: VReservation
  },
  {
    path: '/reservierung/:date?/:people?',
    name: 'reservation-de',
    meta: { lang: 'de' },
    component: VReservation
  },

  // Gift cards
  {
    path: '/giftcards',
    name: 'giftcards-en',
    meta: { lang: 'en' },
    component: VGiftCards
  },
  {
    path: '/gutscheine',
    name: 'giftcards-de',
    meta: { lang: 'de' },
    component: VGiftCards
  },

  // Yullbe
  {
    path: '/yullbe/:date?',
    name: 'yullbe',
    component: VBookingYullbe
  },

  // General
  {
    path: '/terms',
    name: 'terms-en',
    meta: { lang: 'en' },
    component: VTerms
  },
  {
    path: '/agb',
    name: 'terms-de',
    meta: { lang: 'de' },
    component: VTerms
  },

  // Error
  {
    path: '*',
    component: VError
  }
]
